import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import ability from './defineAbility';

export const AbilityContext = createContext<any>(ability);
//@ts-ignore
export const Can = createContextualCan(AbilityContext.Consumer);
